// extracted by mini-css-extract-plugin
module.exports = {"root":"Chat_root__3Dsuu","messages":"Chat_messages__14jV5","dateDivider":"Chat_dateDivider__2rgXy"};